<div class="container-fluid pt-5">
	<div class="row">
		<div class="col-md-12">
			<div class="card shadow-sm">
				<div class="card-body p-5">
					<h3 class="pt-0 pb-4">TSP Scope</h3>

					<!-- start: delete -->
					<!--<form [formGroup]="carrierGroup">
							<div class="form-row">
								<div class="form-group col-md-4">
									<label for="carrier">Carrier</label>
									<select id="carrier" formControlName="carrierSelect" class="w-100">
										<option *ngFor="let c of carriers" [ngValue]=c>{{c.carrierId}} - {{c.scac}} - {{c.scacName}}</option>
									</select>
								</div>
							</div>
						</form>-->
					<!-- end: delete -->

					<div *ngIf="screenState.success.length > 0" class="alert alert-success" role="alert">
						{{screenState.success}}
					</div>

					<div *ngIf="screenState.failure.length > 0" class="alert alert-danger" role="alert">
						{{screenState.failure}}
					</div>

					<p>{{screenState.text}}</p>

					<!--	<div class="row">
							<div class="col-md-6">
								<form [formGroup]="selectionGroup">
									<h6 class="pt-2">Select Scope Type</h6>
									<div class="col-md-3">
										<input type="radio" formControlName="scopeTypeInput" (select)="checkLoad($event.target.value)"
											value="Interstate" name="scopeTypeInput" checked> Interstate
									</div>
									<div class="col-md-3">
										<input type="radio" formControlName="scopeTypeInput" (select)="checkLoad($event.target.value)"
											value="Intrastate" name="scopeTypeInput"> Intrastate
									</div>
									<div class="col-md-3">
										<input type="radio" formControlName="scopeTypeInput" (select)="checkLoad($event.target.value)"
											value="International" name="scopeTypeInput"> International
									</div>
								</form>
							</div>
						</div>
					-->
					<div class="col text-right">
						<button type="button" class="btn btn-outline-secondary btn-sm py-2 w-auto"
							[attr.disabled]="exportDisabled?'':null" (click)='generateDownload()'><i
								class="fa fa-download"></i> Export</button>
						<br>
						<span class="fa fa-warning"></span> Select a ScopeType to Export TspScopeDetails
					</div>
					<div class="row">
						<div class="col-md-6">
							<form [formGroup]="originGroup">
								<h6 class="pt-2">Origins</h6>
								<tree-root #originTreeComponent [nodes]="originTree" [options]="options">
									<ng-template #treeNodeTemplate let-node let-index="index">
										<button type="button" *ngIf="node.data.showPlus" class="btn btn-light py-1 px-2 w-auto mr-2"
											(click)="plus(node, 'Origin')">
											<i class="fa fa-plus" aria-hidden="true"></i>
										</button>
										<button type="button" *ngIf="node.data.showMinus" class="btn btn-light py-1 px-2 w-auto mr-2"
											(click)="minus(node, 'Origin')">
											<i class="fa fa-minus" aria-hidden="true"></i>
										</button>
										<span (click)="select(node, 'origin')">{{ node.data.name }} -
											{{ node.data.code }}</span>
										<span class="child-count"> ({{node.data.children.length}})</span>
										<span class="d-block py-2 px-1" *ngIf="node.data.showAddInput">
											<input type="text" class="input-sm w-75" formControlName="originInput"
												[typeahead]="node.data.list" [typeaheadMinLength]="0"
												[typeaheadOptionsLimit]="10">
											<span *ngIf="node.data.name === interStr && node.data.serviceAreaCount > 1">
												<input type="checkbox" formControlName="originAddServiceToo"> Add other
												states in service area?
											</span>
											<button type="button" class="btn btn-primary btn-sm py-2 px-3 w-auto ml-2"
												(click)="add('Origin', node);">Add</button>
										</span>

									</ng-template>
								</tree-root>
							</form>
						</div>

						<div class="col-md-6">
							<form [formGroup]="destinationGroup">
								<h6 class="pt-2">Destinations</h6>
								<tree-root #destinationTreeComponent [nodes]="destinationTree" [options]="options">
									<ng-template #treeNodeTemplate let-node let-index="index">
										<button type="button" *ngIf="node.data.showPlus" class="btn btn-light py-1 px-2 w-auto mr-2"
											(click)="plus(node, 'Destination')">
											<i class="fa fa-plus" aria-hidden="true"></i>
										</button>
										<button type="button" *ngIf="node.data.showMinus" class="btn btn-light py-1 px-2 w-auto mr-2"
											(click)="minus(node, 'Destination')">
											<i class="fa fa-minus" aria-hidden="true"></i>
										</button>
										<span (click)="select(node, 'destination')">{{ node.data.name }} -
											{{ node.data.code }}</span>
										<span class="child-count"> ({{node.data.children.length}})</span>
										<span class="d-block py-2 px-1" *ngIf="node.data.showAddInput">
											<input type="text" class="input-sm w-75" formControlName="destinationInput"
												[typeahead]="node.data.list" [typeaheadMinLength]="0"
												[typeaheadOptionsLimit]="10">
											<button type="button" class="btn btn-primary btn-sm py-2 px-3 w-auto ml-2"
												(click)="add('Destination', node);">Add</button>
										</span>
									</ng-template>
								</tree-root>
							</form>
						</div>
					</div>

					<button type="button" class="btn btn-primary w-auto" (click)="goBack();">Back to TSP Approval</button>
				</div>
			</div>
		</div>
	</div>
</div>